<template>
  <div class="user-hero">
    <b-overlay :show="loading">
      <template v-if="isHero">
        <b-card border-variant="dark">
          <b-overlay :show="updatingHero" rounded="sm">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h4>اطلاعات رکورددار</h4>
              <div>
                <template v-if="editing">
                  <b-button size="sm" variant="primary" class="mr-1" @click="updateHero">ذخیره</b-button>
                  <b-button @click="editing = false" size="sm" type="primary">انصراف</b-button>
                </template>
                <b-button v-else @click="editing = true" size="sm">ویرایش</b-button>
              </div>

            </div>
            <b-row>
              <b-col cols="6" class="d-flex mb-1" :class="{'flex-column': editing}">
                <div class="mr-2 font-weight-bolder">وزن اولیه:</div>
                <b-form-group v-if="editing" style="margin-top: 5px">
                  <b-form-input
                      id="Title"
                      v-model="heroForm.BeforeWeight"
                      autocomplete="off"
                  />
                </b-form-group>
                <div v-else v-text="hero.BeforeWeight" />
              </b-col>
              <b-col cols="6" class="d-flex mb-1" :class="{'flex-column': editing}">
                <div class="mr-1 font-weight-bolder">طول رژیم:</div>
                <b-form-group v-if="editing" style="margin-top: 5px">
                  <b-form-input
                      id="Title"
                      v-model="heroForm.MonthToGoal"
                      autocomplete="off"
                  />
                </b-form-group>
                <div v-else>{{ `${hero.MonthToGoal} ماه` }}</div>
              </b-col>
              <b-col cols="6" class="d-flex mb-1" :class="{'flex-column': editing}">
                <div class="mr-1 font-weight-bolder">وزن نهایی:</div>
                <b-form-group v-if="editing" style="margin-top: 5px">
                  <b-form-input
                      id="Title"
                      v-model="heroForm.AfterWeight"
                      autocomplete="off"
                  />
                </b-form-group>
                <div v-else v-text="hero.AfterWeight" />
              </b-col>
              <b-col cols="6" class="d-flex mb-1" :class="{'flex-column': editing}">
                <div class="mr-1 font-weight-bolder">وزن کم / زیاد شده:</div>
                <b-form-group v-if="editing" style="margin-top: 5px">
                  <b-form-input
                      id="Title"
                      v-model="heroForm.RecordWeight"
                      autocomplete="off"
                  />
                </b-form-group>
                <div v-else v-text="hero.RecordWeight" />
              </b-col>
              <b-col cols="6" class="d-flex mb-1" :class="{'flex-column': editing}">
                <div class="mr-1 font-weight-bolder">جمله اختصاصی:</div>
                <b-form-group v-if="editing" style="margin-top: 5px">
                  <b-form-input
                      id="Title"
                      v-model="heroForm.Bio"
                      autocomplete="off"
                  />
                </b-form-group>
                <div v-else v-text="hero.Bio" />
              </b-col>
              <b-col cols="6" class="d-flex mb-1" :class="{'flex-column': editing}">
                <div class="mr-1 font-weight-bolder">نوع محتوا:</div>
                <b-form-group v-if="editing" style="margin-top: 5px">
                  <v-select
                      v-model="heroForm.ContentTypeStatus"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      input-id="BannerType"
                      :clearable="false"
                      :options="enums('heroContentType')"
                  />
                </b-form-group>
                <div v-else>{{ enums('heroContentType', 'value', hero.ContentTypeStatus, 'text') }}</div>
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
        <b-card border-variant="dark">
          <b-card-title class="d-flex justify-content-between align-content-center">
            <span style="padding-top: 10px">گالری ارسالی</span>
            <b-button @click="showModal = true" size="sm">افزودن فایل</b-button>
          </b-card-title>
          <hero-gallery-item
              v-for="(media, index) in hero.GalleryList"
              :key="index"
              :media="media"
              @delete="hero.GalleryList.splice(index, 1)"
          />
          <p v-if="hero.GalleryList && !hero.GalleryList.length" class="text-center">هنوز فایل اضافه نکردید</p>
        </b-card>
        <b-card border-variant="dark" title="مقاله درمورد کاربر">
          <b-overlay :show="updatingBlog" rounded="sm">
            <quill-editor
                id="BlogBody"
                :options="snowOption"
                v-model="BlogBody"
            />
            <b-button @click="updateBlog" class="mt-1" variant="primary">ذخیره</b-button>
          </b-overlay>

        </b-card>
        <hero-add-gallery-admin :hero.sync="hero" />
        <b-card border-variant="dark" title="تعیین وضعیت">
          <b-overlay :show="updatingStatus" rounded="sm">
            <b-form-group
                label="وضعیت"
                label-for="Status"
            >
              <v-select
                  v-model="form.status"
                  :options="enums('heroGalleryStatus')"
                  dir="rtl"
                  label="text"
                  :reduce="x => x.value"
                  :clearable="true"
              />
            </b-form-group>
            <b-form-group label="توضیحات" label-for="Description">
              <b-form-textarea v-model="form.adminFeedback" />
            </b-form-group>
            <b-button @click="updateStatus" class="mt-1" variant="primary">ذخیره</b-button>
          </b-overlay>
        </b-card>
      </template>
      <div v-else class="d-flex justify-content-center">
        <b-button @click="addUserToHero" class="mt-1" variant="primary">افزودن کاربر به لیست رکوردداران</b-button>
      </div>
    </b-overlay>
    <hero-add-file-gallery :show.sync="showModal" @add="hero.GalleryList.push($event)" />
  </div>
</template>

<script>
import heroAddFileGallery from "@/views/menu/user/hero/heroAddFileGallery.vue";
import heroGalleryItem from "@/views/menu/user/hero/heroGalleryItem.vue";
import heroAddGalleryAdmin from "@/views/menu/user/hero/heroAddGalleryAdmin.vue";
import { quillEditor } from 'vue-quill-editor'
import uploadFile from "@/tools/uploadFile.vue";
export default {
  name: "userHero",
  components: { uploadFile, heroAddFileGallery, heroGalleryItem, quillEditor, heroAddGalleryAdmin },
  props: {
    userId: { type: [Number, String], default: null },
    isHero: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      updatingBlog: false,
      updatingStatus: false,
      showModal: false,
      editing: false,
      updatingHero: false,
      hero: {},
      BlogBody: '',
      snowOption: {
        theme: 'snow',
      },
      form: {
        userId: '',
        status: '',
        adminFeedback: ''
      },
      fileData: {
        video: null,
        audio: null,
        cover: null
      },
      heroForm: {
        BeforeWeight: '',
        AfterWeight: '',
        MonthToGoal: '',
        RecordWeight: '',
        Bio: '',
        ContentTypeStatus: '',
      }
    }
  },
  watch: {
    isHero: {
      immediate: true,
      handler(val) {
        if (val) this.getHero()
      }
    },
    hero: {
      immediate: true,
      handler(hero) {
        if (hero) {
          this.heroForm.BeforeWeight = hero.BeforeWeight
          this.heroForm.AfterWeight = hero.AfterWeight
          this.heroForm.MonthToGoal = hero.MonthToGoal
          this.heroForm.RecordWeight = hero.RecordWeight
          this.heroForm.Bio = hero.Bio
          this.heroForm.ContentTypeStatus = hero.ContentTypeStatus
        }
      }
    }
  },
  methods: {
    getHero() {
      this.loading = true
      this.$http.get(this.$api.hero.get, { params: { userId: this.userId } }).then(resource => {
        this.hero = resource.data
        this.BlogBody = resource.data.BlogBody
        this.form.status = resource.data.Status
        this.form.adminFeedback = resource.data.AdminFeedback
        this.fileData.video = resource.data.TeaserVideo && resource.data.TeaserVideo.Url
        this.fileData.audio = resource.data.SoundInterview && resource.data.SoundInterview.Url
        this.fileData.cover = resource.data.Cover && resource.data.Cover.Url
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    updateBlog() {
      const data = {
        BlogBody: this.BlogBody,
        UserId: this.userId
      }
      this.updatingBlog = true
      this.$http.post(this.$api.hero.updateHeroBlog, data)
          .then(() => {
            this.updatingBlog = false
          })
          .finally(() => {
            this.updatingBlog = false
          })
    },
    updateStatus() {
      const data = {
        UserId: this.userId,
        Status: this.form.status,
        AdminFeedback: this.form.adminFeedback
      }
      this.updatingStatus = true
      this.$http.post(this.$api.hero.updateHeroStatus, data)
          .then(() => {
            this.updatingStatus = false
          })
          .finally(() => {
            this.updatingStatus = false
          })
    },
    addUserToHero() {
      this.$bvModal.msgBoxConfirm('آیا مطمئن هستید می خواهید این کاربر را به لیست رکوردداران اضافه کنید؟', {
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'تایید',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      }).then(confirm => {
        if (confirm) {
          this.loading = true
          this.$http.get(this.$api.hero.addToHero, { params: { userId: this.userId } })
              .then(() => {
                this.loading = false
                this.$emit('updateUser')
              }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    updateHero() {
      let data = this.heroForm
      data.UserId = this.userId
      this.updatingHero = true
      this.$http.post(this.$api.hero.update, data)
          .then(() => {
            this.updatingHero = false
            this.editing = false
          })
          .finally(() => {
            this.updatingHero = false
          })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>